/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import { InputDate } from "@grapecity/wijmo.input"
import * as wjrInput from "@grapecity/wijmo.react.input"
import * as wjcInput from "@grapecity/wijmo.input"

import queryString from "query-string"
import { useEffect, useRef, useState } from "react"
import dayjs from "dayjs"
import { 区分分類コード } from "../../../constant/enum/codes"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { showInfoToast } from "../../../components/CustomToast"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import KyuzituService from "../../../service/master/kyuzitu/kyuzituService"
import {
  TKyuzituListGetReq,
  TKyuzituListGetRes,
  TKyuzituListPutReq,
} from "../../../service/master/kyuzitu/TKyuzitu"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"

import ConfirmModal from "../../../components/Modal/ConfirmModal"
import { TApiResponse } from "../../../service/TApiResponse"
import _ from "lodash"
import { e休日区分 } from "../../../constant/enum/master"
import { RootState } from "../../../globalStore/rootreducer"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import KubunService from "../../../service/master/kubun/kubunService"

//#region [type]
export type T休日入力Item = TKyuzituListGetRes &
  Partial<{
    // 休日:Date
    行ID: symbol
  }>
//#endregion

/**
 * 休日マスタ
 * @returns
 */
const MasterKyuzituRegister = () => {
  const history = useHistory()
  const location = useLocation()

  // ref
  const ref日付範囲Start = useRef<Date>()
  const ref日付範囲End = useRef<Date>()
  const eigyobi = useSelector((state: RootState) => state.date.eigyobiStr)

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "MasterKyuzituRegister_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<T休日入力Item>) => {
    return new wjCore.CollectionView(data, {
      newItemCreator() {
        return {
          休日日付: new Date(),
          祝日名: "",
          休日区分コード: "1",
          行ID: Symbol(),
        } as unknown as Partial<T休日入力Item>
      },
    })
  }

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionViewSyoteiKyuzitu = (data: Array<T休日入力Item>) => {
    return new wjCore.CollectionView(data, {
      newItemCreator() {
        return {
          休日日付: new Date(),
          祝日名: "",
          休日区分コード: "2",
          行ID: Symbol(),
        } as unknown as Partial<T休日入力Item>
      },
    })
  }

  const beforeSearch = () => {
    // TODO:バリデーションチェック
    if (!isValidationCheckBeforeSearch()) return
    search()
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TKyuzituListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    disPatch(clearAlert()) // アラートを非表示に
    setIsSubmitButton(false)

    // 削除用リストを初期化
    let clearList: TKyuzituListGetRes[] = []
    setGridDataDeleteList(clearList)

    let currentSearchCondition: TKyuzituListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new KyuzituService().getList(currentSearchCondition)

      // 検索結果をstateにセット
      // 削除用リストを作成する
      let copyListSyukuzitu: TKyuzituListGetRes[] = []
      res.data.forEach((d) => {
        // DeepCopy
        copyListSyukuzitu.push(_.cloneDeep(d))
      })
      setGridDataDeleteList(copyListSyukuzitu)

      // 祝日Grid用のリスト
      let gridItem: TKyuzituListGetRes[] = []
      res.data
        .filter(
          (d) =>
            d.休日区分コード === e休日区分.祝日 ||
            d.休日区分コード === e休日区分.会社休日
        )
        .forEach((d) => {
          // DeepCopy
          gridItem.push(_.cloneDeep(d))
        })
      setGridData({ data: createCollectionView(gridItem) })

      // 所定休日Grid用のリスト
      let gridItemSyotei: TKyuzituListGetRes[] = []
      res.data
        .filter((d) => d.休日区分コード === e休日区分.所定休日)
        .forEach((d) => {
          // DeepCopy
          gridItemSyotei.push(_.cloneDeep(d))
        })

      setGridDataSyoteiKyuzitu({
        data: createCollectionViewSyoteiKyuzitu(gridItemSyotei),
      })

      setAccordionController(false)
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
      setIsSubmitButton(true)
      flexGrid?.refresh()
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TKyuzituListGetReq = queryString.parse(location.search)
    set年(query.年!)
    // set年(parseInt(dayjs(query.検索年).format("YYYY")))
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TKyuzituListGetReq => {
    return {
      検索年: dayjs().year(年!).startOf("year").format("YYYY/MM/DD"),
      年,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TKyuzituListGetReq
  ) => {
    return {
      年: searchCondition.年,
    }
  }

  // グリッド初期化時イベントハンドラ　祝日
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }
  // グリッド初期化時イベントハンドラ　所定休日
  const syoteiKyuzituGridInitializedHandler = async (
    grid: wjcGrid.FlexGrid
  ) => {
    grid.formatItem.addHandler(syoteiKyuzituFormatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット 祝日
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      //   const cellBinding = e.getColumn().binding
      //   if (cellBinding !== null && e.getRow().dataIndex !== -1) {
      //     //削除済フラグの行はreadonly
      //     if (e.getRow().dataItem.削除フラグ) {
      //       wjCore.toggleClass(e.cell, "read-only-cell", true)
      //       return
      //     }
      //   }
    }
  }
  /**
   * グリッドのフォーマット 所定休日
   */
  const syoteiKyuzituFormatItem = (
    f: wjcGrid.FlexGrid,
    e: wjcGrid.FormatItemEventArgs
  ) => {
    if (e.panel === f.cells) {
      //   const cellBinding = e.getColumn().binding
      //   if (cellBinding !== null && e.getRow().dataIndex !== -1) {
      //     //削除済フラグの行はreadonly
      //     if (e.getRow().dataItem.削除フラグ) {
      //       wjCore.toggleClass(e.cell, "read-only-cell", true)
      //       return
      //     }
      //   }
    }
  }

  const beforeSubmit = () => {
    // TODO:バリデーションチェック

    setIsConfirmModalShow(true)
  }

  const submit = async () => {
    try {
      // DB更新用リスト
      let dataList: Array<TKyuzituListPutReq> = []

      // 【休日区分：祝日】を追加
      gridData.data.items.forEach((d) => {
        // 新規登録する為、休日IDと更新日時はundefined
        // 削除フラグは0に設定する
        let data: TKyuzituListPutReq = {
          休日ID: undefined,
          休日日付: d.休日日付,
          祝日名: d.祝日名,
          休日区分: d.休日区分コード,
          更新日時: undefined,
          削除フラグ: 0,
        }
        dataList.push(data)
      })

      // 【削除リスト】を追加
      gridDataDeleteList?.forEach((d) => {
        // 削除フラグを1にして追加
        let data: TKyuzituListPutReq = {
          休日ID: d.休日ID,
          休日日付: d.休日日付,
          祝日名: d.祝日名,
          休日区分: d.休日区分コード,
          更新日時: d.更新日時,
          削除フラグ: 1,
        }
        dataList.push(data)
      })

      // 【休日区分：所定休日】を追加
      gridDataSyoteiKyuzitu.data.items.forEach((d) => {
        // 新規登録する為、休日IDと更新日時はundefined
        // 削除フラグは0に設定する
        let data: TKyuzituListPutReq = {
          休日ID: undefined,
          休日日付: d.休日日付,
          祝日名: d.祝日名,
          休日区分: e休日区分.所定休日,
          更新日時: undefined,
          削除フラグ: 0,
        }
        dataList.push(data)
      })

      const service = new KyuzituService()

      let res: TApiResponse<boolean>

      // 更新対象のリストをserviceに渡す。
      res = await service.put(dataList)

      disPatch(setAlerts(res))
      if (res) {
        showInfoToast(`休日マスタの更新が完了しました。`)
      }

      // 遷移してきた際のクエリパラメータで検索条件を生成
      const querySearchCondition = queryParse()

      // リストア中フラグON
      setIsRestoreSearching(true)

      // 再検索
      // Ref更新などをValidationの中で行ってるため、検索前に経由させる。
      search(querySearchCondition).finally(() => {
        disPatch(画面ロック解除())
      })
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  /**
   * 桁数を返す関数
   * @param num
   * @returns
   */
  const numDigits = (num: number) => {
    return num.toString().length
  }

  /**
   * 検索時のチェック
   */
  const isValidationCheckBeforeSearch = () => {
    disPatch(clearAlert())
    Form外エラーメッセージList.splice(0, Form外エラーメッセージList.length)

    let hasError = false
    let messages: Array<string> = []

    // nullチェック
    if (年 == null) {
      messages.push(`年 を入力してください。`)
      hasError = true
    }
    // NaNチェック
    else if (isNaN(年)) {
      messages.push(`数値 を入力してください。`)
      hasError = true
    } else {
      const num = numDigits(年)
      if (4 !== num) {
        messages.push(`年数は YYYY の形式で入力してください。`)
        hasError = true
      }
    }

    if (hasError) {
      Form外エラーメッセージList.push(...messages)
      setHasSearched(hasError)
    } else {
      // 入力日付から、カレンダー制御用変数に範囲設定する。
      ref日付範囲Start.current = dayjs().year(年!).startOf("year").toDate()
      ref日付範囲End.current = dayjs().year(年!).endOf("year").toDate()
    }
    return !hasError
  }
  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)
  const [isSyoteiKyuzituRestoreSearching, setIsSyoteiKyuzituRestoreSearching] =
    useState<boolean>(false)

  const [pageSize, setPageSize] = useState<number>(10)

  // 祝日グリッド用
  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([]),
  })
  // 所定休日グリッド用
  const [flexGridSyoteiKyuzitu, setFlexGridSyoteiKyuzitu] =
    useState<wjcGrid.FlexGrid>()
  const [gridDataSyoteiKyuzitu, setGridDataSyoteiKyuzitu] = useState<{
    data: wjCore.CollectionView
  }>({
    data: createCollectionViewSyoteiKyuzitu([]),
  })
  // 削除アイテムリスト
  const [gridDataDeleteList, setGridDataDeleteList] =
    useState<TKyuzituListGetRes[]>()

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中
  const [isSubmitButton, setIsSubmitButton] = useState(false) // 検索後

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const disPatch: AppDispatch = useDispatch()

  // errorフラグ
  const [hasSearched, setHasSearched] = useState(false)
  const [Form外エラーメッセージList] = useState<string[]>([])

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)
  const [syoteiKyuzituGridInitialized, setsyoteiKyuzituGridInitialized] =
    useState<boolean>(false)

  //#endregion

  //#region [state]
  // state
  const [年, set年] = useState<number>(parseInt(dayjs(eigyobi).format("YYYY")))

  const [休日区分DataMap, set休日区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  //#endregion

  //#region [effect]

  useEffect(() => {
    document.title = `休日マスタ`
    // 初期表示生成のため画面ロック
    disPatch(画面ロック開始())

    // set年(parseInt(dayjs(eigyobi).format("YYYY")))
  }, [])

  //kubun
  useEffect(() => {
    Promise.all([new KubunService().getList()]).then(([区分マスタRes]) => {
      set休日区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data
            .filter((d) => d.分類コード === 区分分類コード.マスタ.休日区分)
            .filter((d) => d.区分コード !== e休日区分.所定休日),
          "区分コード",
          "名称1"
        )
      )
    })
  }, [])

  // error監視
  useEffect(() => {
    if (hasSearched && [...Form外エラーメッセージList].find((e) => e !== "")) {
      disPatch(setWarningAlerts([...Form外エラーメッセージList]))
    }
    setHasSearched(false)
  }, [hasSearched])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && syoteiKyuzituGridInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)
        setIsSyoteiKyuzituRestoreSearching(true)

        // 再検索
        // Ref更新などをValidationの中で行ってるため、検索前に経由させる。
        // if (isValidationCheckBeforeSearch()) {
        search(querySearchCondition).finally(() => {
          disPatch(画面ロック解除())
        })
        // }
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        disPatch(画面ロック解除())
        if (isValidationCheckBeforeSearch()) {
          search()
        }
      }
    }
  }, [gridInitialized, syoteiKyuzituGridInitialized])

  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">休日マスタ</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-30rem">
            {/* CardHeaderをアコーディオン化 ⇒ 入力対象キーでもあるため、一旦制御無し */}
            <Card.Header
              // onClick={() => setAccordionController(!accordionController)}
              onClick={() => setAccordionController(true)}
              aria-controls="collapse-search-card-body"
              aria-expanded={true}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={true}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    {/* 固定項目 */}
                    <Row>
                      <Col>
                        <div className="w-4rem">
                          <wjrInput.InputNumber
                            initialized={(control: wjcInput.InputNumber) => {
                              control.inputElement?.focus()
                            }}
                            style={{ width: "5rem" }}
                            id="年"
                            name="年"
                            format={"g0"}
                            // focus
                            isRequired={true}
                            value={年}
                            valueChanged={(c: wjcInput.InputNumber, e: any) => {
                              c.value != null
                                ? set年(c.value)
                                : set年(parseInt(dayjs(eigyobi).format("YYYY")))
                            }}
                          />
                        </div>
                      </Col>
                      <Col className="text-end">
                        <Button
                          type="submit"
                          disabled={isSearching}
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            beforeSearch()
                          }}>
                          <FontAwesomeIcon icon={faSearch} />
                          検索
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card className="w-60rem">
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              {/* 休日区分ごとにGridを分割 */}
              <div className="d-flex">
                <div className="overflow-auto">
                  <FlexGridOuter
                    flexGrid={flexGrid}
                    setFlexGrid={setFlexGrid}
                    gridConstantProperties={
                      CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT
                    }
                    gridData={gridData}
                    setGridData={setGridData}
                    pageNumber={0}
                    gridId={`${gridId}_1`}
                    isRestoreSearching={isRestoreSearching}
                    setIsRestoreSearching={setIsRestoreSearching}
                    gridInitialized={gridInitialized}
                    setGridInitialized={setGridInitialized}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    gridInitializedHandler={gridInitializedHandler}
                    isShowGridRowPickupButton={false}
                    isShowGridFooter={false}>
                    <wjrGrid.FlexGridColumn
                      binding="休日日付"
                      width={130}
                      format="d"
                      editor={
                        new wjcInput.InputDate(document.createElement("div"), {
                          max: dayjs(ref日付範囲End.current).format(
                            "YYYY-MM-DD"
                          ),
                          min: dayjs(ref日付範囲Start.current).format(
                            "YYYY-MM-DD"
                          ),
                        })
                      }
                      isRequired
                      header="休日">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(
                          context: TWijmoCellTemplateContext<T休日入力Item>
                        ) => {
                          let dDate = ""
                          if (context.item.休日日付)
                            dDate = dayjs(context.item.休日日付).format(
                              "YYYY/MM/DD"
                            )
                          return (
                            <>
                              <span>{dDate}</span>
                            </>
                          )
                        }}></wjrGrid.FlexGridCellTemplate>
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="祝日名"
                      width={160}
                      header="祝日名"></wjrGrid.FlexGridColumn>

                    <wjrGrid.FlexGridColumn
                      binding="休日区分コード"
                      width={160}
                      dataMap={休日区分DataMap}
                      header="休日区分"></wjrGrid.FlexGridColumn>
                  </FlexGridOuter>
                </div>
                <div className="overflow-auto" style={{ paddingLeft: "3rem" }}>
                  <FlexGridOuter
                    flexGrid={flexGridSyoteiKyuzitu}
                    setFlexGrid={setFlexGridSyoteiKyuzitu}
                    gridConstantProperties={
                      CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT
                    }
                    gridData={gridDataSyoteiKyuzitu}
                    setGridData={setGridDataSyoteiKyuzitu}
                    pageNumber={0}
                    gridId={`${gridId}_2`}
                    isRestoreSearching={isSyoteiKyuzituRestoreSearching}
                    setIsRestoreSearching={setIsSyoteiKyuzituRestoreSearching}
                    gridInitialized={syoteiKyuzituGridInitialized}
                    setGridInitialized={setsyoteiKyuzituGridInitialized}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    gridInitializedHandler={syoteiKyuzituGridInitializedHandler}
                    isShowGridRowPickupButton={false}
                    isShowGridFooter={false}>
                    <wjrGrid.FlexGridColumn
                      binding="休日日付"
                      width={130}
                      format="d"
                      editor={
                        new InputDate(document.createElement("div"), {
                          max: dayjs(ref日付範囲End.current).format(
                            "YYYY-MM-DD"
                          ),
                          min: dayjs(ref日付範囲Start.current).format(
                            "YYYY-MM-DD"
                          ),
                        })
                      }
                      isRequired
                      header="所定休日">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(
                          context: TWijmoCellTemplateContext<T休日入力Item>
                        ) => {
                          return (
                            <>
                              <span>
                                {dayjs(context.item.休日日付).format(
                                  "YYYY/MM/DD"
                                )}
                              </span>
                            </>
                          )
                        }}></wjrGrid.FlexGridCellTemplate>
                    </wjrGrid.FlexGridColumn>
                  </FlexGridOuter>
                </div>
              </div>

              <Row>
                <Col>
                  <div>
                    <Button
                      type="button"
                      variant={isSubmitButton ? "waiting" : "secondary"}
                      disabled={!isSubmitButton}
                      onClick={() => {
                        beforeSubmit()
                      }}>
                      登録
                    </Button>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で更新しますか？
      </ConfirmModal>
    </Container>
  )
}

export default MasterKyuzituRegister
